/*
    boost-pfs-filter override logic
    if customer who not logged in this website doesn't show price
    if customer who tagged wholesales in this website apply discount prices
*/
(function() {
    const target = document.getElementsByClassName("boost-pfs-filter-products")[0];

    const observer = new MutationObserver(function () {
        var products = target.getElementsByClassName("product");
        for (let i of products) {
            let productLink = i.getElementsByClassName("product-link");
            let priceElements = i.getElementsByClassName("product__price-price");
            let urlStrings = productLink[0].href.split("/");
            let productID = urlStrings.slice(-1)[0];
            let country_code = "";

            if (currency_country_code == "JPY") {
                country_code = "JP";
            } else if (currency_country_code == "CNY") {
                country_code = "CN";
            } else if (currency_country_code == "USD") {
                country_code = "US";
            } else {
                country_code = currency_country_code;
            }

            var productPrice = 0;
            if (logged_in) {
                if (has_discount) {
                    jQuery.getJSON("/products/" + productID + ".js", function(product) {
                        productPrice = product.price_min / 100;
                        priceElements[0].innerHTML = `
                                        <span class="money">
                                            <del>${country_code}${Utils.formatMoney(productPrice)}</del>
                                            ${country_code}${Utils.formatMoney(productPrice * discount)}
                                        </span>
                                        `;
                    });
                } else {
                    jQuery.getJSON("/products/" + productID + ".js", function(product) {
                        productPrice = product.price_min / 100;
                        priceElements[0].innerHTML = `
                                        <span class="money">
                                            ${country_code}${Utils.formatMoney(productPrice)}
                                        </span>
                                        `;
                    });
                }
            } else {
                priceElements[0].innerHTML = "";
            }
    
        }
      });
    
    const config = { attributes: true, childList: true, characterData: true };
    
    observer.observe(target, config);
})();
